import React from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { useStore } from "../../../../store";
import { SECTIONS } from "../../../../constants/sections";
import { SavingsListItem } from "../../../molecules/savings-list-item";
import { Graph } from "../../../molecules/graph";
import { Flex } from "../../../atoms/flex";
import { Wave } from "../../../atoms/wave";
import { UNITS } from "../../../../constants/units";

/**
 * Water section component
 */
export const Water = () => {
  const { data, loading } = useStore();

  return (
    <>
      <Wave className="fill-white" variant={3} />
      <Section className="bg-white" id={SECTIONS.WATER} wave>
        {/* <Wave /> */}
        <Header
          icon="water"
          title={SECTIONS.WATER}
          subTitle={`${Math.round(
            data?.waterSavedL || 0
          )} Liter har sparats, återvinningsgrad på ${Math.round(
            data?.waterReductionInPercent || 0
          )}${UNITS.PERCENT}`}
          loading={loading}
        />
        <Flex className="section-content">
          <Flex className="savings-list">
            <SavingsListItem
              text="Mängden vatten en vanlig tvättmaskin förbrukar per
                        tvätt."
              value="50-100"
              unit={UNITS.LITER}
              loading={loading}
            />
            <SavingsListItem
              text="Vad era tvättmaskiner förbrukar per tvätt. "
              value={Math.round(data?.waterPerWashWithoutAMimbox || 0)}
              unit={UNITS.LITER}
              loading={loading}
            />
            <SavingsListItem
              text="Antalet tvättar som gjorts sedan installation av
                        Mimboxen."
              value={Math.round(data?.numberOfWashes || 0)}
              unit={UNITS.PER_UNIT}
              loading={loading}
            />
            <SavingsListItem
              text="Genomsnittlig vattenförbrukning per tvätt med Mimbox
                        installerad."
              value={Math.round(data?.waterPerWashWithAMimbox || 0)}
              unit={UNITS.LITER}
              loading={loading}
            />
          </Flex>
          <Graph
            description="Vattenförbrukning"
            max={data?.totalWaterL}
            min={data?.tapWaterL}
            unit={UNITS.LITER}
            loading={loading}
          />
        </Flex>
      </Section>
    </>
  );
};
